import { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'whitespace-nowrap font-medium rounded-lg transition-all duration-200 cursor-pointer inline-flex items-center justify-center';
  
  const variants = {
    primary: 'bg-orange-600 text-white hover:bg-orange-700 active:bg-orange-800',
    secondary: 'bg-gray-800 text-white hover:bg-gray-900 active:bg-black',
    outline: 'border-2 border-orange-600 text-orange-600 hover:bg-orange-50 active:bg-orange-100',
    ghost: 'text-gray-700 hover:bg-gray-100 active:bg-gray-200'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-2.5 text-base',
    lg: 'px-8 py-3 text-lg'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}